import type { FC, ReactNode } from "react";
import { Content } from "src/shared/components/content";
import type { ContentId } from "src/shared/components/content";
import {
  AboutUsContainer,
  CustomerProofBackgroundCircle,
  CustomerProofSectionCol,
  CustomerProofSectionContainer,
  CustomerProofSectionDiv,
  CustomerProofSectionRow,
  CustomerProofSectionText,
  CustomerProofTitle,
  SectionTitle,
} from "src/website-apps/responsive/stubhub-about-us/components/viagogo/styled-components";
import { Covered as CoveredSvg } from "./assets/Covered";
import { ForTheFuture as ForTheFutureSvg } from "./assets/ForTheFuture";
import { Safe as SafeSvg } from "./assets/Safe";
import { TicketToFreedom as TicketToFreedomSvg } from "./assets/TicketToFreedom";
import { Transparency as TransparencySvg } from "./assets/Transparency";

interface CustomerProofSectionBodyProps {
  readonly contentIdTitle: ContentId;
  readonly contentIdText: ContentId;
  readonly icon: ReactNode;
}

const CustomerProofSectionBody: FC<CustomerProofSectionBodyProps> = ({ contentIdTitle, contentIdText, icon }) => (
  <CustomerProofSectionCol span={[12, 12, 6, 3]}>
    <CustomerProofSectionDiv>
      <CustomerProofBackgroundCircle>{icon}</CustomerProofBackgroundCircle>
      <CustomerProofSectionText>
        <CustomerProofTitle>
          <Content id={contentIdTitle} />
        </CustomerProofTitle>
        <div>
          <Content id={contentIdText} />
        </div>
      </CustomerProofSectionText>
    </CustomerProofSectionDiv>
  </CustomerProofSectionCol>
);

export const CustomerCharter: FC = () => (
  <AboutUsContainer>
    <SectionTitle>
      <Content id="cid$#2984335#" />
    </SectionTitle>
    <CustomerProofSectionContainer>
      <CustomerProofSectionRow>
        {/* Ticket to Freedom */}
        <CustomerProofSectionBody
          contentIdTitle="cid$#2984762#"
          contentIdText="cid$#2984763#"
          icon={<TicketToFreedomSvg />}
        />
        {/* Safe and regulated */}
        <CustomerProofSectionBody contentIdTitle="cid$#2984764#" contentIdText="cid$#2984778#" icon={<SafeSvg />} />
      </CustomerProofSectionRow>
      <CustomerProofSectionRow>
        {/* Total transparency */}
        <CustomerProofSectionBody
          contentIdTitle="cid$#2984765#"
          contentIdText="cid$#2984779#"
          icon={<TransparencySvg />}
        />
        {/* We’ve got you covered */}
        <CustomerProofSectionBody contentIdTitle="cid$#2984766#" contentIdText="cid$#2984780#" icon={<CoveredSvg />} />
      </CustomerProofSectionRow>
      <CustomerProofSectionRow>
        {/* For the future */}
        <CustomerProofSectionBody
          contentIdTitle="cid$#2984767#"
          contentIdText="cid$#2984781#"
          icon={<ForTheFutureSvg />}
        />
      </CustomerProofSectionRow>
    </CustomerProofSectionContainer>
  </AboutUsContainer>
);
